module.exports = __webpack_public_path__ + "img/RocketLaunchOutlined.ea695a93.svg";